import useInvoiceTickets from '~/data/hooks/useInvoiceTickets';
import type { Invoice } from '~/data/schemas/invoice';
import type { Ticket } from '~/data/schemas/ticket';

/**
 * An adjustment with no tickets of its own is backed by the original invoice's tickets,
 * the same rule the AI review applies. `undefined` while that is still being worked out.
 */
export function useParentTickets(
  invoice: Invoice | undefined,
  tickets: Ticket[] | undefined,
): Ticket[] | undefined {
  const parentId = invoice?.parentInvoice?.id;
  const needsParent = parentId !== undefined && tickets?.length === 0;
  const { tickets: parentTickets, error } = useInvoiceTickets(needsParent ? parentId : null);

  if (!invoice?.parentInvoice) return [];
  if (tickets === undefined) return undefined;
  if (!needsParent || error) return [];
  return parentTickets;
}
